import roundCustom from "./RoundCustom";

const Porcentagem = {
    obter: (menor, maior) => roundCustom(menor * 100 / maior, 2),
    calcular: (menor, maior) => roundCustom((menor * maior) / 100),
};

export default Porcentagem;